import { cleanPermalink } from './top-videos';
import { detectLanguage } from './detect-language';

import type { ReportRow } from './export-account-report-sheets';
import type { AccountStatRow } from './stat-row';

/**
 * Строка статистики → строка отчёта.
 *
 * Отчёты показывают ТОЛЬКО органические просмотры. Рекламная часть живёт в
 * r.paid и наружу не идёт: её видно на экране, но в выгрузки она не попадает —
 * так решили при внедрении разбивки, и менять это без отдельного решения
 * нельзя. Вынесено из AccountsStatsPage, чтобы правило держалось тестом, а не
 * одной строкой посреди девятисот.
 */
export function reportRowFromStat(
  row: AccountStatRow,
  theme: string,
  imageUrl: string,
): ReportRow {
  return {
    permalink: cleanPermalink(row.permalink ?? ''),
    publishedAt: row.timestamp,
    views: row.views,
    theme,
    language: theme ? detectLanguage(theme) : '',
    imageUrl,
  };
}
